import { CapoPlugin } from "/home/mycrashbaggage/webapps/mycrashbaggage/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];